/**
 * Route name to restore after a signed-out visitor logs in.
 * Auth0 carries the name back on /callback; query and hash do not.
 * Only dashboard pages are remembered, so a registration or close-account
 * URL does not replace a return page that was already chosen.
 */
export function loginReturnRouteName(to: {
  name?: string | symbol | null
  meta?: { layout?: string }
}): string | null {
  if (
    typeof to.name === 'string' &&
    to.name &&
    to.meta?.layout === 'DashboardLayout'
  ) {
    return to.name
  }
  return null
}
